var React = require('react');

function CaretRight (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M184 256a19.41 19.41 0 0 1-5.29 13.37l-.8.8L43.64 399.08C30.49 411.71 8 402.76 8 384.91V256z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M8 256V127.07c0-17.85 22.48-26.8 35.63-14.17L177.9 241.82c.27.26.54.53.8.81A19.39 19.39 0 0 1 184 256z","className":"fa-primary","key":2})]);
}

CaretRight.defaultProps = {"viewBox":"0 0 192 512","className":"icon"};

module.exports = CaretRight;

CaretRight.default = CaretRight;
